var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('checkbox',{attrs:{"value":_vm.isFeatured},on:{"input":_vm.updateFeatured}},[_vm._v(_vm._s(_vm.$t('Featured Product')))])
}
var staticRenderFns = []

export { render, staticRenderFns }